import React from "react";
// import classnames from 'classnames';
import PropTypes from "prop-types";

const maskingNumber = "*";
const TextFieldGroup = ({
  field,
  value,
  label,
  error,
  type,
  onChange,
  checkUserExists,
  className,
  fromInfutor,
  resetVin,
  cVin,
  display,
}) => (
    <span className={`${className} reset-vin`}>
      {}
      <input
        onChange={onChange}
        onBlur={checkUserExists}
        // value={value}
        type={type}
        name={field}
        placeholder={label}
        value={
          value ? cVin === value && fromInfutor
            ? value.length > 4
              ? maskingNumber.repeat(value.length - 4) +
              value.substr(value.length - 4, 4)
              : value
            : value : ''
        }
        className="form-control validate"
        disabled={fromInfutor}
      />
      {display && fromInfutor === false ? <a onClick={resetVin}>Reset</a> : ''}

      {error && <span className="help-block invalid ">{error}</span>}
    </span>
  );

TextFieldGroup.propTypes = {
  field: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.string,
  error: PropTypes.any,
  type: PropTypes.string,
  onChange: PropTypes.func,
  checkUserExists: PropTypes.func
};

TextFieldGroup.defaultProps = {
  type: "text",
  fromInfutor: false,
  display: false,
  className: ''
};

export default TextFieldGroup;
